var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.306 4.175 1.276.965L9.481 19.825l-6.063-5.29 1.052-1.206 4.769 4.16L19.306 4.176Z",
    fill: "#303030"
  })));
};
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuMzA1OCA0LjE3NTI5TDIwLjU4MjEgNS4xNDAxOEw5LjQ4MDY2IDE5LjgyNDhMMy40MTc5MiAxNC41MzQzTDQuNDY5OTEgMTMuMzI4N0w5LjIzODkxIDE3LjQ4OTdMMTkuMzA1OCA0LjE3NTI5WiIgZmlsbD0iIzMwMzAzMCIvPgo8L3N2Zz4K";